import React from 'react';
import styled from 'styled-components';
import Link from '@mui/material/Link';
import Tooltip from '@mui/material/Tooltip';
import EditIcon from '@mui/icons-material/Edit';

import { currency } from 'shared/components/tables';
import SvgFile from 'shared/components/SvgFile';
import TrueImpactBadge from 'shared/design-system/components/TrueImpactBadge';

/* const ColorBubble = styled.div`
  background: ${({ color = '#ccc' }) => color};
  border-radius: 20px;
  padding: 0 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  ${({ width }) => width && `width: ${width}px;`}
`;*/

const Row = styled.div`
  display: flex;
`;

/* const Stage = styled.div`
  font-size: 24px;
`;
*/

/* const stageColors = {
  initial: '#cc8', //'linear-gradient(to right, #ecc, #caa)',
  interim: '#dd8',
  final: '#8e8', //'linear-gradient(to right, #8e8, #8c8)',
  unallocated: '#e88',
}; */

/* const statusColors = {
  draft: '#d88',
  rejected: '#e88',
  waiting: '#cc8', //'linear-gradient(to right, #cc8, #aa8)',
  finalized: '#8c8', //'linear-gradient(to right, #8e8, #8c8)',
  published: '#8e8', // 'linear-gradient(to right, #8c8, #8a8)',
  tiFeedbackProvided: '#ee8', //'linear-gradient(to right, #ee8, #cc8)',
  unallocated: '#e88',
}; */

const stages = {
  None: 0,
  Initial: 1,
  Act: 2,
  Capacity: 2,
  Catalyze: 2,
  Interim: 2,
  Learn: 2,
  Succeed: 2,
  Reach: 2,
  Final: 3,
};
// const array3 = new Array(3).fill(null).map((_, index) => index);

/*  const StageDiagramOld = ({ stage }) => (
  <Stage>
    {array3
      .reduce(
        (all, index) => [
          ...all,
          stage > index ? '●' : '○',
          index < 2 ? '⎯' : '',
        ],
        [],
      )
      .join('')}
  </Stage>
); */

const StageDiagram = ({ stage }) =>
  stage ? <img src={`/images/stage${stage}.png`} /> : null;

const Scaler = styled.div`
  transform: scale(${({ scale }) => scale});
`;

const RowText = styled.span`
  line-height: 30px;
`;

/* const NextTaskDueText = styled.div`
  color: ${({ color }) => color};
  background-color: ${({ backgroundColor }) => backgroundColor};
  height: 24px;
  border-radius: 12px;
  width: 85px;
  text-align: center;
`;
*/

/* const NextTaskDue = ({ value }) => {
  const level = value < 0 ? 0 : value < 7 ? 1 : 2;
  const colors = ['red', '#888844', '448844'];
  const backgroundColors = ['#fcd7d9', '#fbe3b9', '#cdedcd'];

  return (
    <NextTaskDueText
      color={colors[level]}
      backgroundColor={backgroundColors[level]}
    >
      {value} days
    </NextTaskDueText>
  );
}; */

const ShowOnHover = styled.div.attrs({
  className: 'show-on-hover',
})``;

const statusSvgNames = {
  Finalized: 'Finalized',
  'TI Feedback Provided': 'Feedback Provided',
  Published: 'Published',
  Draft: 'Draft',
  'Not Started': 'Not Started',
  Submitted: 'Submitted',
};

export const tableCols = [
  {
    headerName: 'NPO name',
    field: 'grantee.name',
    menuTabs: ['filterMenuTab'],
    width: 250,
    valueGetter: ({ data: { invitations }, value }) =>
      invitations?.[0]?.organization || value,
  },
  {
    headerName: 'Program',
    field: 'programName',
    width: 250,
    cellRenderer: ({ data, value }) => {
      if (data.investmentId && value && value !== '-') {
        return (
          <a
            style={{ color: '#0091ae' }}
            onClick={() =>
              window.open(
                `/donor/impact-receipt/${data.investmentId}${
                  data.allocationId ? `?allocationId=${data.allocationId}` : ''
                }`,
              )
            }
          >
            {value}{' '}
            {value === 'Impact3' && <TrueImpactBadge>legacy</TrueImpactBadge>}
          </a>
        );
      }
      return 'Not yet allocated';
    },
  },
  {
    headerName: 'Year',
    field: 'year',
    //    filter: 'agNumberColumnFilter',
    width: 60,
  },
  {
    headerName: 'Stage',
    field: 'report.stage',
    width: 80,
    //    valueGetter: ({ value }) => startCase(camelCase(value)) ?? 'Unallocated',
    cellRenderer: ({ value }) => (
      <Tooltip title={value ?? 'Unallocated'} arrow>
        <Scaler scale={0.7}>
          <StageDiagram stage={stages[value] ?? 0} />
        </Scaler>
      </Tooltip>
    ),
  },
  {
    headerName: 'Status',
    field: 'combinedStatus',
    width: 120,
    valueGetter: ({ value }) => value ?? 'Unallocated',
    cellRenderer: ({ value }) => (
      <Row>
        {statusSvgNames[value] && (
          <Scaler scale={0.7}>
            <SvgFile src={`/images/svg/Status-${statusSvgNames[value]}.svg`} />
          </Scaler>
        )}
        <RowText>&nbsp;{value}</RowText>
      </Row>
      //      <ColorBubble color={statusColors[camelCase(value)]} width={104}>{value}</ColorBubble>
    ),
  },
  // {
  //   headerName: 'Next Task Due',
  //   field: 'timelinesTask',
  //   valueGetter: ({ value, data }) => {
  //     const stage = data.report?.stage;
  //     if (!stage) {
  //       return null;
  //     }

  //     const timeline = value?.find(
  //       ({ label }) => stage.toLowerCase() === label.toLowerCase(),
  //     );

  //     return timeline;
  //   },
  //   cellRenderer: ({ value }) =>
  //     value ? (
  //       <Tooltip title={value.details}>
  //         <NextTaskDue value={value.days} />
  //       </Tooltip>
  //     ) : (
  //       ''
  //     ),
  //   width: 130,
  // },
  {
    //    filter: 'agNumberColumnFilter',
    headerName: 'Donation',
    field: 'amount',
    width: 110,
    type: currency,
    cellRenderer: ({ value }) =>
      value && (
        <Link color="#0091ae">
          <Row>
            <RowText>{value}</RowText>&nbsp;
            <ShowOnHover>
              <EditIcon size="small" />
            </ShowOnHover>
          </Row>
        </Link>
      ),
  },
  /*
  {
//    filter: 'agNumberColumnFilter',
    headerName: 'Budget',
    field: 'totalBudgetInitial',
    width: 80,
    type: currency,
  },*/
  {
    headerName: 'Impact Model',
    field: 'report.service',
    flex: 1,
  },
  // {
  //   headerName: 'Reach',
  //   field: 'totalReached',
  //   width: 80,
  //   type: number,
  // },
  // {
  //   headerName: 'Impacts',
  //   field: 'impacts',
  //   flex: 1,
  //   tooltipValueGetter: ({ value }) => {
  //     const list = value?.split(' | ')?.slice(0, 7);
  //     if (value?.length > 7) {
  //       list.push(`& ${value?.length - 7} more...`);
  //     }
  //     return (
  //       <ul>
  //         {list?.map((row, index) => (
  //           <li key={`${row}-${index}`}>{row}</li>
  //         ))}
  //       </ul>
  //     );
  //   },
  // },
];
